import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 relative overflow-hidden" data-id="element-88">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cyan-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-89" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-90">
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-91">
          {/* Glow effect inside card */}
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-amber-500/20 rounded-full blur-[60px]" data-id="element-92" />
          <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-cyan-500/20 rounded-full blur-[60px]" data-id="element-93" />

          <img src="https://cdn.magicpatterns.com/uploads/xf9YcrEtCFHSFiMHXxrvbA/Untitled_design_(2).png" alt="Método Cero Ruido" className="w-full max-w-md mx-auto rounded-xl mb-8 border border-white/10 shadow-[0_0_30px_rgba(0,212,255,0.1)]" data-id="element-94" />

          <h2 className="text-3xl md:text-4xl font-bold text-slate-50 mb-6" data-id="element-95">
            Recupera el mando de tu mañana hoy mismo.
          </h2>

          <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto" data-id="element-96">
            Por el precio de un par de cafés, puedes tener la herramienta que
            silencia el caos cada vez que lo necesites.
          </p>

          <div className="mb-10" id="precio" data-id="element-97">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-500/20 border border-red-500/30 text-red-400 text-sm font-bold mb-4 animate-pulse" data-id="element-98">
              🔥 OFERTA POR TIEMPO LIMITADO — 55% OFF
            </div>
            <p className="text-lg text-slate-400 mb-3" data-id="element-99">
              Consigue el Método Cero Ruido por solo
            </p>
            <div className="flex items-center justify-center gap-4 mb-1" data-id="element-100">
              <span className="text-3xl font-bold text-slate-500 line-through decoration-red-500/70 decoration-2" data-id="element-101">
                $27 USD
              </span>
            </div>
            <div className="text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600 drop-shadow-sm" data-id="element-102">
              $12.15 USD
            </div>
            <p className="text-sm text-cyan-400/80 mt-2 font-medium" data-id="element-103">
              Ahorras $14.85 hoy
            </p>
          </div>

          <CTAButton className="w-full sm:w-auto sm:px-12 py-5 text-xl mb-6" data-id="element-104">
            ACCEDER AL MÉTODO AHORA
          </CTAButton>

          <div className="flex flex-col items-center gap-3 text-sm text-slate-400" data-id="element-105">
            <p className="flex items-center gap-2" data-id="element-106">
              <span className="text-cyan-500" data-id="element-107">✓</span> Descarga instantánea.
              Empieza a silenciar el ruido en 2 minutos.
            </p>
            <div className="flex items-center gap-2 mt-4 text-slate-500" data-id="element-108">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-109" />
              <span data-id="element-110">Pago 100% seguro y encriptado</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}